import { TravelTimeChart } from 'features/chart/TravelTimeChart';
import { Map } from 'features/map/Map';
import { withSegmentTooltip } from 'features/map/hooks/withSegmentTooltip';
import { TaskBar } from 'features/task_bar/TaskBar';
import { NoRouteSelectedPanel } from 'features/workflow_common/RouteInstructions/NoRouteSelectedPanel';
import { ChartSettings } from 'features/workflow_nrt/ChartSettings';
import {
  VisualisationRegion,
  WorkflowNrtSkeleton,
} from 'features/workflow_nrt/WorkflowRecent';

import { ReliesOn } from '../workflow_common/NoDataLoadedWarning';
import {
  WorkflowInfo,
  maybeCarryOverDates,
  maybeCarryOverRouteSelection,
} from '../workflow_common/workflowLookup';

export const workflowTravelTime: WorkflowInfo = {
  dataAvailableReliesOn: [ReliesOn.nrtDay, ReliesOn.typicalMonth],
  switchToState: (fromWorkflow, state) => {
    maybeCarryOverDates(state, fromWorkflow);
    maybeCarryOverRouteSelection(state, fromWorkflow);
  },
};
const MapWithTooltip = withSegmentTooltip(Map);

export function WorkflowTravelTime() {
  return (
    <WorkflowNrtSkeleton
      vizRegionComponent={
        <VisualisationRegion
          graph_title="Travel Time"
          unselected_state_fn={NoRouteSelectedPanel}
        >
          <TravelTimeChart />
        </VisualisationRegion>
      }
      mapComponent={<MapWithTooltip enableRouteSelection />}
      taskBarComponent={
        <TaskBar segmentInfo="route" savedRoutes="regular">
          <ChartSettings />
        </TaskBar>
      }
    />
  );
}
